export function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms))
}

export const hideOldFriends = ["0", "-29%", "-50%"]
